import { useGetAccountContextQuery } from 'src/graphql/generated';
import type { DashboardAccountContext } from 'src/types';
import { getDevContext } from 'src/utils/config';

// This might return NULL if this data has not been set up for a hirer
export const useAccountContext = () => {
  const { loading, error, data } = useGetAccountContextQuery();

  if (loading) {
    return { loading, error, data: null };
  }

  if (error) {
    // Handle Unauthenticated error - redirect to login (or tell a dev)
    if (
      error.graphQLErrors?.find(
        (gqlError) => gqlError.extensions?.code === 'UNAUTHENTICATED',
      )
    ) {
      if (getDevContext()) {
        throw new Error('Your local auth token is expired or invalid');
      }
    }

    return { loading: false, error, data: null };
  }

  let accountContextCurrentAdvertiser = null;

  if (data?.currentAdvertiser?.__typename === 'CurrentAdvertiserContext') {
    accountContextCurrentAdvertiser = {
      ...data.currentAdvertiser,
    };
  }

  return {
    loading,
    error,
    data: {
      currentAdvertiser: accountContextCurrentAdvertiser,
      emailVerified: data?.emailVerified,
      advertiser: data?.headerFooterContext?.advertiser,
      identityContext: data?.headerFooterContext?.identityContext,
      user: data?.headerFooterContext?.user,
    } as DashboardAccountContext,
  };
};
